import React, { useState } from "react";
import Icon from "./CommonIcon/Icon";
import ConditionalLink from "./ConditionalLink";

export const AnnouncementStrip = ({
  url,
  description,
  onClose,
}: {
  url: string | null;
  description: string | null;
  onClose: () => void;
}) => {
  return (
    <div className="bg-gray-text">
      <section>
        <div className="flex justify-between md:justify-center gap-16 py-12 px-20 items-center">
          {/* @ts-ignore */}
          <ConditionalLink
            link={url}
            className="font-mulish text-12-20 md:text-14-24 text-white">
            {description}
          </ConditionalLink>
          <div className="cursor-pointer" onClick={onClose}>
            <Icon name="close" fontSize="text-16" color="text-white" />
          </div>
        </div>
      </section>
    </div>
  );
};
